// extracted by mini-css-extract-plugin
module.exports = {"status":"RegistrationDetails_status__YPi1t","registrationDetailsPlaceholder":"RegistrationDetails_registrationDetailsPlaceholder__PXtu3"};